import { Pipe, PipeTransform } from "@angular/core";
import { NumberUtils } from "@mra/hlp9002";

@Pipe({
    name: "monnaie",
    standalone: true
})
export class MonnaiePipe implements PipeTransform {
    /**
     * formatte un montant
     * @param valeur - montant
     * @returns montant formatté
     */
    transform(valeur: number | "" | undefined): string {
        if (valeur === "" || valeur === undefined) return "";
        return NumberUtils.formatterMonnaie(valeur);
    }
}
